module.exports = __webpack_public_path__ + "img/anatomic-cooling.53b57e3.svg";